/**
 * 요금제군 이름에서 애매한 연산자 낱말("이상/초과/이하/미만/전체")을 지운다.
 * 카탈로그 라벨이 "110K 이상"·"109K 이상 (P_119)"·"3만원 이상"처럼 제각각 저장돼 있어,
 * 끝이든 괄호 안이든 그 낱말만 도려내고 남은 빈 괄호·중복 공백을 정리한다. 전부 지워 비면 원문 유지.
 */
export function stripBandWords(s: string): string {
  const out = s
    .replace(/\s*(이상|초과|이하|미만|전체)(?=$|\s|\)|·|,)/g, "")
    .replace(/\(\s*\)/g, "")
    .replace(/\s+\)/g, ")")
    .replace(/\s{2,}/g, " ")
    .trim();
  return out || s;
}
